import { Search } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export const UsersPanelHeader = ({
  handleSearch,
}: {
  handleSearch: (search: string, activeCityOnly: boolean) => void;
}) => {
  const { t } = useTranslation();

  const [search, setSearch] = useState("");
  const [activeCityOnly, setActiveCityOnly] = useState(false);

  return (
    <div className="flex items-center gap-4">
      <div className="relative flex-1">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400 pointer-events-none" />
        <input
          type="text"
          placeholder={t("Enter User ID")}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="w-full pl-10 pr-4 py-2 rounded-md border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-primaryText dark:text-primaryTextDark focus:outline-none focus:ring-2 focus:ring-secondaryText dark:focus:ring-secondaryTextDark"
        />
      </div>

      <button
        type="button"
        onClick={() => setActiveCityOnly(!activeCityOnly)}
        className={`flex items-center gap-2 px-4 py-2 rounded-md border text-sm transition
          ${
            activeCityOnly
              ? "bg-secondaryText dark:bg-secondaryTextDark text-primaryText"
              : "bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-300"
          }`}
      >
        <span
          className={`w-3 h-3 rounded-full transition
            ${activeCityOnly ? "bg-primaryText" : "bg-gray-400"}`}
        />
        {t("Search within active city?")}
      </button>

      <button
        type="button"
        className="px-5 py-2 rounded-md bg-secondaryText text-white text-sm hover:opacity-90 transition"
        onClick={() => handleSearch(search, activeCityOnly)}
      >
        {t("Search")}
      </button>
    </div>
  );
};
